/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_No_Event_AddedInputs */



/**
* | output |
* | --- |
* | "No event (added)" |
*
* @param {Compare_Event_Groups_No_Event_AddedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_no_event_added = /** @type {((inputs?: Compare_Event_Groups_No_Event_AddedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_No_Event_AddedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun événement (ajouté)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Ereignis (hinzugefügt)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento (aggiunto)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событий нет (добавлено)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ningún evento (añadido)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无事件（已添加）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントなし（追加）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई इवेंट नहीं (जोड़ा गया)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum evento (adicionado)")
	return /** @type {LocalizedString} */ ("No event (added)")
});